import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box, Skeleton, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import Field from '../field'
import useAccountPrivacyFields from './useAccountPrivacyFields'
import {FormattedMessage} from 'react-intl'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import useSiteType from '../../hooks/use-site-type'

const AccountPrivacyFields = ({form, prefix = ''}) => {
    const {isUS} = useSiteType()
    const {data: customer, isLoading} = useCurrentCustomer()
    const [defaultValues, setDefaultValues] = useState({
        analytical: false,
        promo: false
    })
    const {control, reset} = form

    const marketingConsentDate = customer?.c_marketingConsentDate || ''
    const shareConsentDate = customer?.c_shareConsentDate || ''

    const fields = useAccountPrivacyFields({form, prefix, control})

    const formatDate = (dateParam) => {
        const date = new Date(dateParam)
        return date.toLocaleDateString()
    }

    useEffect(() => {
        if (!isLoading && customer) {
            setDefaultValues({
                analytical: customer?.c_shareConsent || false,
                promo: customer?.c_marketingConsent || false
            })
        }
    }, [isLoading])

    // Reset form values when defaultValues change
    useEffect(() => {
        reset(defaultValues)
    }, [defaultValues, reset])

    return (
        <Skeleton isLoaded={!isLoading}>
            <Stack spacing={24} maxWidth={{base: 'unset', lg: 524}}>
                <Box>
                    <Field
                        {...fields.analytical}
                        defaultValue={defaultValues.analytical}
                        control={control}
                    />
                    {shareConsentDate && !isUS && (
                        <Text variant={'bodyBase1'} ml={'20px'}>
                            <FormattedMessage
                                defaultMessage={'Updated'}
                                id="account_privacy.updated"
                            />{' '}
                            {formatDate(shareConsentDate)}
                        </Text>
                    )}
                </Box>
                <Box>
                    <Field {...fields.promo} defaultValue={defaultValues.promo} control={control} />
                    {marketingConsentDate && (
                        <Text variant={'bodyBase1'} ml={'20px'}>
                            <FormattedMessage
                                defaultMessage={'Updated'}
                                id="account_privacy.updated"
                            />{' '}
                            {formatDate(marketingConsentDate)}
                        </Text>
                    )}
                </Box>
            </Stack>
        </Skeleton>
    )
}

AccountPrivacyFields.propTypes = {
    form: PropTypes.object.isRequired,
    prefix: PropTypes.string
}

export default AccountPrivacyFields
